import { TransactionReturnReason } from '@frontend/transaction/types';
import { FormattedMessage, useIntl } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import useWearableReturnReason from './wearable-return-reason.controller';

const ID = 'wearable-return-reason';

const WearableReturnReason = () => {
    const intl = useIntl();
    const viewProps = useWearableReturnReason();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isProcessing,
                onClose: viewProps.stopProcessing
            }}
            footer={{
                submitDisabled: !viewProps.selectedReason,
                onSubmit: viewProps.handleSubmit
            }}>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='text-foreground-default justify-end'>
                    <FormattedMessage
                        id='kiosk.wizard.return-detail.returning'
                        defaultMessage='Returning'
                    />
                </div>
                <ProductCard
                    product={viewProps.product}
                    equipment={viewProps.equipment}
                />

                <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                    <div className='text-foreground-default justify-end'>
                        <FormattedMessage
                            defaultMessage='Why are you returning this product?'
                            id='kiosk.wizard.wearable-return-reason.label'
                            description='Label for the section where the user can provide their return reason'
                        />
                    </div>
                    <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                        <RadioButton
                            onClick={() => viewProps.setSelectedReason(TransactionReturnReason.WRONG_SIZE)}
                            selected={viewProps.selectedReason === TransactionReturnReason.WRONG_SIZE}
                            text={intl.formatMessage({
                                defaultMessage: 'Wrong size',
                                id: 'kiosk.wizard.wearable-return-reason.wrong-size'
                            })}
                        />
                        <RadioButton
                            onClick={() => viewProps.setSelectedReason(TransactionReturnReason.WRONG_PRODUCT)}
                            selected={viewProps.selectedReason === TransactionReturnReason.WRONG_PRODUCT}
                            text={intl.formatMessage({
                                defaultMessage: 'Wrong product',
                                id: 'kiosk.wizard.wearable-return-reason.wrong-product'
                            })}
                        />
                        <RadioButton
                            onClick={() => viewProps.setSelectedReason(TransactionReturnReason.DAMAGED)}
                            selected={viewProps.selectedReason === TransactionReturnReason.DAMAGED}
                            text={intl.formatMessage({
                                defaultMessage: 'Damaged',
                                id: 'kiosk.wizard.wearable-return-reason.damaged'
                            })}
                        />
                    </div>
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default WearableReturnReason;

const RadioButton = ({ disabled, text, onClick, selected }: { disabled?: boolean; text: string; onClick: () => void; selected: boolean }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            data-variant='Detailed'
            className='bg-background-surface disabled:bg-background-default border-border-default inline-flex items-center justify-start gap-4 self-stretch rounded-xl border px-4 py-3'>
            <div
                data-variant='Checked'
                className={`h-4 w-4 ${disabled ? 'bg-background-default' : 'bg-background-surface'} border-border-default flex items-center justify-center rounded-full border`}>
                <div className={`size-2.5 rounded-full ${selected ? 'bg-brand-primary' : ''}`} />
            </div>

            <div className='inline-flex flex-1 flex-col items-start justify-center gap-0.5'>
                <div className={`justify-start ${disabled ? 'text-brand-disabled' : 'text-foreground-default'} text-base font-semibold`}>{text}</div>
            </div>
        </button>
    );
};
